import classNames from 'classnames';

import { useHasOverflow } from '../hooks/useHasOverflow';
// eslint-disable-next-line css-modules/no-unused-class
import postStyles from '../styles/posts.module.css';

export const TruncatedSummary: React.FC<{ children: JSX.Element; maxHeight?: number }> = ({ children, maxHeight }) => {
	const [overflow, ref] = useHasOverflow();
	return (
		<>
			<div
				ref={ref}
				style={{ maxHeight: maxHeight || 200 }}
				className={classNames({
					[postStyles.overflow]: overflow.hasOverflow
				})}
			>
				{children}
			</div>
		</>
	);
};
